export class Banco {
  idbanco?: number;
  codigo?: string;
  nombre?: string;
  abreviatura?: string;
  editando?: boolean;
  constructor() {}
}
